import rewardSVG from 'assets/icons/rewards.svg'
import close from 'assets/icons/close-white.svg'
import { useAppSelector } from 'state/hooks'
import { hideDistributionBanner, selectShowDistributionBanner } from 'state/slices/ui/dash'

export function DistributionBanner() {
  const show = useAppSelector(selectShowDistributionBanner)
  if (!show) return null
  return (
    <div className="reward-banner">
      <div className="reward-banner__left">
        <img src={rewardSVG} alt="reward" />
        <div className="reward-banner__content">
          <h3>Week 53 rewards have been distributed!</h3>
          <p>
            The MOVE rewards spanning the week of April 23, 2026 through April 29, 2026 have been
            deposited to all eligible portfolios.
          </p>
        </div>
      </div>
      <img src={close} alt="close" className="clickable" onClick={hideDistributionBanner} />
    </div>
  )
}
